function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { Proposition } from '../../../config/internal-config';
import { sdkLogger } from '../../../logger';
import { getFactoryLoader, loadBaseFactory, loadTizenFactory, loadWebOsFactory, loadWithYospaceFallback } from '../../ad-insertion/ad-insertion-factories';
var adInsertionLogger = sdkLogger.withContext('oneAppAdFactories');
export function oneAppAdInsertionFactory(adInsertionConfig, device) {
    return _oneAppAdInsertionFactory.apply(this, arguments);
}
function _oneAppAdInsertionFactory() {
    _oneAppAdInsertionFactory = _async_to_generator(function(adInsertionConfig, device) {
        var _obj, advertsMapping;
        return _ts_generator(this, function(_state) {
            if (!(adInsertionConfig === null || adInsertionConfig === void 0 ? void 0 : adInsertionConfig.enabled)) return [
                2
            ];
            advertsMapping = (_obj = {}, _define_property(_obj, DeviceType.Browser, loadBaseFactory), _define_property(_obj, DeviceType.WebOS, loadWebOsFactory), _define_property(_obj, DeviceType.Vizio, loadBaseFactory), _define_property(_obj, DeviceType.XboxOne, loadBaseFactory), _define_property(_obj, DeviceType.XboxSeries, loadBaseFactory), _define_property(_obj, DeviceType.WinUI2, loadBaseFactory), _define_property(_obj, DeviceType.Kepler, loadBaseFactory), _define_property(_obj, DeviceType.Chromecast, loadBaseFactory), _define_property(_obj, DeviceType.Tizen, loadTizenFactory), _define_property(_obj, DeviceType.Xfinity, loadBaseFactory), _define_property(_obj, DeviceType.WebMaf, loadWithYospaceFallback), _define_property(_obj, DeviceType.Android, loadWithYospaceFallback), _define_property(_obj, DeviceType.Vidaa, loadBaseFactory), _define_property(_obj, DeviceType.Prospero, loadBaseFactory), _define_property(_obj, DeviceType.OneSdk, loadBaseFactory), _define_property(_obj, DeviceType.Kpn, loadBaseFactory), _define_property(_obj, DeviceType.Quest, loadBaseFactory), _define_property(_obj, DeviceType.Ion, loadBaseFactory), _obj);
            return [
                2,
                getFactoryLoader({
                    device: device,
                    proposition: Proposition.OneApp,
                    advertsMapping: advertsMapping,
                    adInsertionConfig: adInsertionConfig,
                    adInsertionLogger: adInsertionLogger
                })
            ];
        });
    });
    return _oneAppAdInsertionFactory.apply(this, arguments);
}

//# sourceMappingURL=oneapp-factories.js.map